<form autocomplete="off" [formGroup]="formGroup" (ngSubmit)="save()">
    <h4>Detalle del estado de encuesta <small> </small></h4>
    <hr>

    <div class="col-12">
        <div class="form-group row">

            <div class="textOnInput col-12">
                <label class="form-label" for="inputText">Estado</label>
                <input class="form-control form-input" type="text" placeholder="Denominación del estado"
                    formControlName="label" autocomplete="off" [class.is-invalid]="campoNoValido('label')">
                <small class="text-danger" *ngIf="campoNoValido('label')">Ingrese el nombre del equipo</small>
            </div>

            <div class="textOnInput col-12">
                <label class="form-label" for="inputText">Detalle</label>
                <textarea class="form-control" formControlName="detail" placeholder="Detalle del estado" autocomplete="off" rows="6"></textarea>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="d-flex justify-content-start">
                    <div class="me-2">
                        <button class="btn btn-outline-secondary btn-block"
                            [routerLink]="['/encuesta/org/estados/list']">
                            Cancelar
                        </button>
                    </div>
                    <div class="col-6 input-group">
                        <button type="submit" class="btn btn-outline-primary btn-block">
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</form>